'use strict';

exports.__esModule = true;
exports.type = undefined;
exports.reduce = reduce;
exports.ron2js = ron2js;

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _ronUuid = require('@swarm/ron-uuid');

var _ronUuid2 = _interopRequireDefault(_ronUuid);

var _iheap = require('./iheap');

var _iheap2 = _interopRequireDefault(_iheap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = exports.type = _ronUuid2.default.fromString('lww');

var heap = new _iheap2.default(_iheap.refComparator, _iheap.eventComparatorDesc);

// Last-write-wins reducer.
function reduce(batch) {
  batch = batch.filter(function (f) {
    return !!f.body;
  });
  var ret = new _ron.Frame();
  if (!batch.length) return ret;
  batch.sort().reverse();

  for (var _iterator = batch, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var frame = _ref;

    if (batch.length === 1) return frame;
    for (var _iterator2 = frame, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var op = _ref2;

      ret.push(new _ron2.default(type, op.uuid(1), op.uuid(2), _ronUuid.ZERO, undefined, _ron.FRAME_SEP));

      heap.clear();
      heap.put(batch);

      while (!heap.eof()) {
        var current = heap.current();
        if (!current) break;
        ret.pushWithTerm(current, ',');
        heap.nextPrim();
      }

      return ret;
    }
  }

  return ret;
}

function ron2js(rawFrame) {
  var ret = {};
  var proto = {};
  proto.type = 'lww';
  var lww = new _ron.Frame(rawFrame);
  var length = 0;
  var latest = _ronUuid.ZERO;

  for (var _iterator3 = lww.unzip().reverse(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref3 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref3 = _i3.value;
    }

    var op = _ref3;

    if (!proto.id) {
      proto.id = op.uuid(1).toString();
      proto.uuid = op.uuid(1);
      latest = op.event;
    }
    if (!op.uuid(1).eq(proto.uuid) || !op.isRegular()) continue;

    var value = op.value(0);

    var key = op.location.toString();
    if (op.location.isHash()) {
      if (op.location.value !== '~') {
        throw new Error('only flatten arrays are being supported');
      }
      key = op.location.origin;
    }
    if (length > -1) {
      var p = parseInt(key);
      if (!isNaN(p)) {
        length = Math.max(p + 1, length);
      } else {
        length = -1;
      }
    }
    ret[key] = {
      value: value,
      writable: false,
      enumerable: true
    };
  }

  proto.version = latest.toString();

  if (Object.keys(ret).length > 1 && length > 0) {
    proto.length = length;
    proto.values = function () {
      return Array.prototype.slice.call(this);
    };
    // $FlowFixMe
    proto.valueOf = function () {
      return this.values();
    };
    proto[Symbol.iterator] = function () {
      return this.values()[Symbol.iterator]();
    };
    proto.toJSON = function () {
      return JSON.stringify(this.values().map(function (i) {
        if (i instanceof _ronUuid2.default) {
          return '#' + i.toString();
        } else return i;
      }));
    };
  }

  return Object.create(proto, ret);
}

exports.default = { reduce: reduce, type: type, ron2js: ron2js };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/rdt/lib/lww.js
// module id = 73
// module chunks = 0